export default {
  baseStyle: {
    header: {
      fontSize: 'xl',
      fontWeight: 'semibold',
      fontFamily: 'heading',
    },
  },
}
